import {CleanedLocale, FormatCurrency} from "./types";

const currencies = {
  "en-US": "USD",
  "en-CA": "CAN",
  "fr-CA": "CAN",
};

export const makeFormatCurrency = (locale: CleanedLocale): FormatCurrency => (
  value: number,
  options?: Intl.NumberFormatOptions
) => {
  const currency = currencies[locale];
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    ...options,
  });
  return formatter.format(value);
};
